export const BrandImageLarge = ({ pic }) => {
  return (
    <div className="projects-opening-brand-container">
      <img className="projects-opening-brand-large" src={pic} />
    </div>
  );
};
